import { render, staticRenderFns } from "./aftersaleOverview.vue?vue&type=template&id=3157cc13&scoped=true&"
import script from "./aftersaleOverview.vue?vue&type=script&lang=js&"
export * from "./aftersaleOverview.vue?vue&type=script&lang=js&"
import style0 from "./aftersaleOverview.vue?vue&type=style&index=0&id=3157cc13&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3157cc13",
  null
  
)

export default component.exports